import { useTranslation } from 'react-i18next';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { Button } from '@framework/ui/atoms/Button';
import { BuildInfo } from '@config/build-info';
import { RTDBConsoleURL } from '@admin/firebase';
import { usePrimitiveValueListener } from '@framework/repository';
import { RTDBPath } from 'balus-common';

type Props = {
  onClose(): void;
};

export const BuildInfoModal: React.FC<Props> = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const [requiredVersion] = usePrimitiveValueListener<number | null>(RTDBPath.ApplicationConfig.requiredVersionPath());

  return (
    <GeneralModal
      isOpen={true}
      onClose={onClose}
      title={t('framework.topNav.buildInfoTitle')}
      submitButton={<></>}
      cancelButton={
        <Button onClick={onClose} color={'secondary'}>
          {t('common.action.close')}
        </Button>
      }
    >
      <div className="flex flex-col p-4">
        <div className="flex flex-row py-2">
          <span className="pr-2 font-bold">{t('framework.topNav.buildDate')}</span>
          <span>{BuildInfo.DATE}</span>
        </div>
        <div className="flex flex-row py-2">
          <span className="pr-2 font-bold">{t('framework.topNav.buildNumber')}</span>
          <span>{BuildInfo.version.toString()}</span>
          <span className="flex items-end pl-2 text-sm">
            <a
              href={RTDBConsoleURL.build(RTDBPath.ApplicationConfig.requiredVersionPath())}
              className="text-indigo-500 hover:underline"
              target="_blank"
              rel="noreferrer"
            >
              {t('framework.topNav.requiredVersion', {
                requiredVersion: requiredVersion ?? t('framework.topNav.notSet'),
              })}
            </a>
          </span>
        </div>
        <div className="flex flex-row py-2">
          <span className="pr-2 font-bold">Git SHA1</span>
          <span>{BuildInfo.SHA1}</span>
        </div>
      </div>
    </GeneralModal>
  );
};
